import { Button } from 'src/shared/components/ui/buttons/button'
import { DirectionArrow } from 'src/shared/features/users/assets/direction-arrow'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

import AuthBackground from './auth-background'

const AuthSidebar = () => {
  const isMobile = useIsMobile()

  return (
    <div
      className={cn(
        'relative flex max-w-[1100px] flex-col overflow-clip',
        isMobile ? 'w-full bg-white' : 'w-full bg-primary',
      )}
    >
      <AuthBackground />
      <div
        className={cn(
          'absolute bottom-0 right-0 w-full items-center justify-end gap-4 bg-primary p-10',
          isMobile ? 'hidden' : 'flex',
        )}
      >
        <p className="text-white">Learn more about Conrad and see who&apos;s allowed on the network</p>
        <a href="https://joinconrad.ai" target="_blank" rel="noopener noreferrer">
          <Button variant="accent" size="default" className="w-max gap-3">
            <p className="w-max">Click here</p>
            <DirectionArrow size={20} />
          </Button>
        </a>
      </div>
    </div>
  )
}

export default AuthSidebar
